export interface WhiteLabelSettings {
  whitelabel_enabled: boolean;
  wl_brand_name: string | null;
  wl_logo_url: string | null;
  wl_primary_color: string | null;
  wl_secondary_color: string | null;
  wl_custom_domain: string | null;
  wl_from_email: string | null;
  wl_from_name: string | null;
}

export interface BrandingConfig {
  brandName: string;
  logoUrl: string;
  primaryColor: string;
  secondaryColor: string;
  isWhiteLabel: boolean;
}

export const DEFAULT_BRANDING: BrandingConfig = {
  brandName: 'NLP OS',
  logoUrl: '/nlp_os_logo_off_white_creme_bg_.png',
  primaryColor: '#1F3D2E',
  secondaryColor: '#A69884',
  isWhiteLabel: false,
};

export const DEFAULT_EMAIL_LOGO = 'https://my.nlpos.app/nlp_os_logo.png';

export function resolveBranding(wl: WhiteLabelSettings | null): BrandingConfig {
  if (!wl || !wl.whitelabel_enabled) {
    return DEFAULT_BRANDING;
  }
  return {
    brandName: wl.wl_brand_name || DEFAULT_BRANDING.brandName,
    logoUrl: wl.wl_logo_url || DEFAULT_BRANDING.logoUrl,
    primaryColor: wl.wl_primary_color || DEFAULT_BRANDING.primaryColor,
    secondaryColor: wl.wl_secondary_color || DEFAULT_BRANDING.secondaryColor,
    isWhiteLabel: true,
  };
}
